import {FieldType} from "../../../fields3/field-type";
import FieldsCollection from "../../../fields3/collection/base/fields-collection";
import {EntityType} from "../../../gd/const/item";
import FieldUser from "../../../fields3/generic/user/user";


const baseConfig = [
    {
        fieldId         : 'tasksReassignUserId',
        type            : FieldType.USER,
        label           : 'Tasks Reassign To',
    },
    {
        fieldId         : 'eventsReassignUserId',
        type            : FieldType.USER,
        label           : 'Events Reassign To',
    },
    {
        fieldId         : 'projectReassignUserId',
        type            : FieldType.USER,
        label           : 'Projects Reassign To',
    },
]

export default class UserAssignment_Fields extends FieldsCollection {

    get tasksReassignUserId()       { return this.get('tasksReassignUserId') as FieldUser }
    get eventsReassignUserId()      { return this.get('eventsReassignUserId') as FieldUser }
    get projectReassignUserId()     { return this.get('projectReassignUserId') as FieldUser }

    constructor() {
        super(baseConfig, EntityType.DYNAMIC_MODEL)
    }
}
